import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MwcModalRef, MwcModalService } from 'mwc/modal';
import { Subject } from 'rxjs';
import { GenerationInProgressPopupComponent } from 'src/app/_shared/modules/shared-ui/components/generation-in-progress-popup/generation-in-progress-popup.component';
import { AIWaitingInfo } from '../../../models/topic';
@Injectable({
    providedIn: 'root'
})
export class GenerationInProgressHelperService {

  private cancelEventSource = new Subject<void>();
  cancelEvent$ = this.cancelEventSource.asObservable();
  private modalService;
  private modalRef;
  private seoAnalysisList: { title: string; desc?: string }[] = [
    /* { 'title': 'Focus on Quality Content', 'desc': 'Ensure your content is informative, engaging, and valuable to your audience' },
    { 'title': 'Optimize for Keywords', 'desc': 'Research and use relevant keywords naturally in your content to improve visibility' },
    { 'title': 'Use Descriptive URLs', 'desc': 'Make URLs descriptive, short, and keyword-rich to enhance understanding and SEO' },
    { 'title': 'Optimize Title Tags', 'desc': 'Include target keywords in title tags while making them compelling to click' },
    { 'title': 'Craft Compelling Meta Descriptions', 'desc': 'Write unique and enticing meta descriptions for each page to improve click-through rates.' },
    { 'title': 'Utilize Header Tags', 'desc': 'Structure your content with H1, H2, and H3 tags to improve readability and SEO.' },
    { 'title': 'Optimize Images', 'desc': 'Use descriptive filenames and alt text for images to improve accessibility and relevance.' },
    { 'title': 'Improve Site Speed', 'desc': 'Ensure your website loads quickly on all devices to reduce bounce rates and enhance user experience.' },
    { 'title': 'Mobile-Friendly Design', 'desc': 'Optimize your website for mobile users to cater to the increasing mobile traffic.' },
    { 'title': 'Secure Your Site with HTTPS', 'desc': 'Implement HTTPS to secure your site and boost its ranking signal.' },
    { 'title': 'Create Quality Backlinks', 'desc': 'Gain backlinks from reputable sites to enhance your site’s credibility and search ranking.' },
    { 'title': 'Use Social Media to Boost Visibility', 'desc': 'Share your content on social media platforms to increase traffic and engagement.' },
    { 'title': 'Implement Local SEO Practices', 'desc': 'Optimize your site for local search terms and listings to attract local customers.' },
    { 'title': 'Monitor Your Sites Performance', 'desc': 'Use tools like Google Analytics and Search Console to track traffic, performance, and issues.' },
    { 'title': 'Update Content Regularly', 'desc': 'Keep your site fresh with regular updates and new content to engage visitors and search engines.' },
    { 'title': 'Optimize for Voice Search', 'desc': 'Include conversational keywords and FAQs to capture voice search queries.' },
    { 'title': 'Use Internal Linking Wisely', 'desc': 'Create internal links to guide visitors to relevant content, improving site navigation and SEO.' },
    { 'title': 'Avoid Duplicate Content', 'desc': 'Ensure your content is unique across your site to avoid penalties from search engines.' },
    { 'title': 'Leverage Schema Markup', 'desc': 'Implement structured data to help search engines understand and display your content more prominently.' },
    { 'title': 'Stay Updated with SEO Practices', 'desc': 'SEO is ever-evolving; stay informed about the latest trends and algorithm updates to keep your site competitive.' } */
     { title: 'Create Content at Scale', desc: 'Use “My Projects” to take one content idea and generate multiple pieces of content at once.' },
    { title: 'Avoid Duplicate Content', desc: 'Use our “Readability Analysis” on your content draft to check for plagiarism and readability.' },
    { title: 'Optimize Your Draft', desc: 'Use our “SEO Checklist” on long-form web content to enhance your content for search visibility.' },
    { title: 'Add FAQs to Your Content', desc: 'Answer the questions your audience has by generating FAQs for your content draft with one click.' },
    { title: 'Add Images to Your Content', desc: 'Upload images and add captions, or insert images directly from Milestone’s Digital Asset Manager.' },
    { title: 'Repurpose Existing Content', desc: 'Use “Content Repurpose” to take one piece of content and rewrite it to fit another content format.' },
    { title: 'Translate Your Content', desc: 'Create multiple translations for your content using AI that all sync to your original content draft.' },
    { title: 'Export Your Content', desc: 'Export any content draft to .PDF, .DOC, HTML, or JSON for easy publishing to your platform of choice.' }
  ];

  openWaitingPopup(data: AIWaitingInfo[], textTitle: string = null, isForCampaignGenerationIdeas:boolean=false, isForBulkMeta:boolean = false, isCloseable:boolean = false) {
    if (data == null || data.length === 0) {
      data= this.getRandomItems(this.seoAnalysisList, 3)
    }
    this.createTemplate(data, textTitle, isForCampaignGenerationIdeas, isForBulkMeta, isCloseable);
  }

getRandomItems = (list: any[], count: number): any[] => {
  const shuffled = list.sort(() => 0.5 - Math.random()); // Shuffle the list
  return shuffled.slice(0, count); // Return the first `count` items
};


  init(modalService: MwcModalService) {
    this.modalService = modalService;
  }

  closeTemplateSelector() {
    if (this.modalRef)
      this.modalRef.close();
  }

  createTemplate(data: AIWaitingInfo[], textTitle: string = null, isForCampaignGenerationIdeas: boolean = false, isForBulkMeta: boolean = false, isCloseable:boolean=false) {
    this.modalRef = this.modalService.create({
      mwcData: {
        sliderData: data,
        textTitle: textTitle,
        isForCampaignGenerationIdeas: isForCampaignGenerationIdeas,
        isForBulkMeta: isForBulkMeta
      },
      mwcClosable:isCloseable,
      mwcBodyStyle:{'padding':'32px 32px 20px 32px'},
      mwcTitle: null,
      mwcWidth: '320px',
      mwcCentered: true,
      mwcContent: GenerationInProgressPopupComponent,
      mwcClassName: 'waiting-popup-modal',
      mwcFooter:null,
      mwcMaskClosable: false,
      mwcOnCancel: () => {
        this.cancelEventSource.next();
      }
    });
  }
  seoAnalysisListReturn(){
    return this.getRandomItems(this.seoAnalysisList, 3);
  }
}
